/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Emailcannotbethesame4Inputs */

const en_form_emailcannotbethesame4 = /** @type {(inputs: Form_Emailcannotbethesame4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email cannot be the same as primary email`)
};

/**
* | output |
* | --- |
* | "Email cannot be the same as primary email" |
*
* @param {Form_Emailcannotbethesame4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const form_emailcannotbethesame4 = /** @type {((inputs?: Form_Emailcannotbethesame4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Emailcannotbethesame4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_form_emailcannotbethesame4(inputs)
});
export { form_emailcannotbethesame4 as "form_emailCannotBeTheSame" }